var _g, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrowPrevious = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 26,
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 26,
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 26,
  fill: "white"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 22,
  fill: "white"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 22,
  fill: "white"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 22,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.1071 19.7577L24.4872 25.5L30.1071 31.2418L28.378 33L21 25.5L28.378 18L30.1071 19.7577Z",
  fill: "black"
})));
export default SvgIconArrowPrevious;